/**
 * Sales Invoice Credited For Formatter.
 */
window.salesInvoiceCreditedForFormatter = function(value, row) {
    let html = '';
    if (can('admin.sales.invoices.show') && row.credited_for) {
        html += '<a href="/admin/sales/invoices/show/'+row.credited_for_id+'">';
        html += row.credited_for;
        html += '</a>';
    } else if (can('tuijncode.invoices') && row.credited_for) {
        html += '<a href="/tuijncode/invoices/show/'+row.credited_for_id+'">';
        html += row.credited_for;
        html += '</a>';
    }
    return html;
}
